import {
  Data_Object_Keys,
  getBarcodeSize,
  getDataObjectKey,
} from "../../constants/barcodes";
import { getBarcodeLabels } from "../../containers/BarcodeEditorPreview/helper";
import { downloadZplFile } from "../../utils/zplBarcode";

const defaultGap = 5 / 32;
const defaultMargin = {
  top: 0.5,
  left: defaultGap,
  bottom: 0.5,
  right: defaultGap,
};

export const barcodeMapper = (data, type) => ({
  name: data?.name,
  top: data?.top || [],
  bottom: data?.bottom || [],
  delimiter: data?.delimiter,
  format: data?.format,
  label: !!data?.label,
  object: type ?? Number(data?.object),
  serialize: !!data?.serialize,
  size: Number(data?.size),
  barcode: data?.barcode?.map((field, idx) => ({
    field: field?.field,
    format: field?.format,
    padding: Number(field?.padding || 0),
    order: idx,
  })),
  pageType: data?.pageType ?? 1,
  margin: data?.margin || defaultMargin,
  columns: data?.columns ?? 3,
  columnGap: data?.columnGap ?? defaultGap,
  rows: data?.rows ?? 10,
  rowGap: data?.rowGap ?? 0,
  source: data?.source ?? 1,
});

const getQuantity = (source, data) => {
  if (!data) return 1;
  const key = getDataObjectKey(source)?.key;
  const qty = key ? data[key] : 1;

  return qty;
};
export const getBarcodeDefaults = (data, sd) => ({
  name: data?.name || "",
  top: data?.top || [],
  bottom: data?.bottom || [],
  delimiter: data?.delimiter || "-",
  format: data?.format || "CODE39",
  label: data?.label ?? true,
  object: Number(data?.object) || 1,
  serialize: data?.serialize ?? 1,
  size: Number(data?.size) || 1,
  barcode: data?.barcode?.map((field, idx) => ({
    field: field?.field,
    format: field?.format,
    padding: Number(field?.padding || 0),
    order: idx,
  })),
  pageType: data?.pageType ?? 1,
  margin: data?.margin || defaultMargin,
  columns: data?.columns ?? 3,
  columnGap: data?.columnGap ?? defaultGap,
  rows: data?.rows ?? 10,
  rowGap: data?.rowGap ?? 0,
  source: data?.source ?? 1,
  quantity: getQuantity(data?.source ?? 1, sd),
});

export const handleDownloadZplHelper = ({
  formData,
  data,
  snackbar,
  useBmp = true,
  returnString,
}) => {
  const dimensions = getBarcodeSize(formData.size);
  const width = Number(dimensions?.width?.replace(/[^\d.x]/g, ""));
  const height = Number(dimensions?.height?.replace(/[^\d.x]/g, ""));

  const fields = formData?.barcode;
  const delimiter = formData?.delimiter;
  const serialize = !!formData?.serialize;
  const topTemplates = formData?.top || [];
  const bottomTemplates = formData?.bottom || [];
  const source = formData?.source;
  const barcodeFormat = formData?.format;
  const key = Data_Object_Keys.find((dok) => dok.id === source)?.key;

  let qty = 1;
  if (source === 5) qty = formData?.quantity || 1;
  else qty = data[key] || 1;

  const size = { width, height, unit: "in", dpi: 203 };

  const labels = getBarcodeLabels({
    data,
    fields,
    delimiter,
    serialize,
    topTemplates,
    bottomTemplates,
    quantity: qty,
    useBmp,
    barcodeFormat,
    size,
  });

  // console.log({ labels });

  return downloadZplFile({
    format: formData?.format,
    showLabel: !!formData?.label,
    size,
    barcodes: labels,
    filename: "labels.zpl",
    snackbar,
    returnString,
  });
};
